import { ClassName } from "@/helpers/pageHelpers/Common/interface";

export enum SubheadingVariant {
  FollowedPodcasts = "followed",
  PersonalFeed = "personalFeed",
}

export interface EmptyStateInterface {
  className?: ClassName;
  heading?: string;
  subheading?: string;
  withIcon?: boolean;
  withButton?: boolean;
  variant?: SubheadingVariant;
}
